module.exports = __webpack_public_path__ + "static/media/flag.d07bd4be.svg";